<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="">
    <div v-html="innerHtml"></div>
  </div>
</template>

<script>
import { getHeaderHtml } from '@/api'
import $ from 'jquery'
export default {
  data() {
    return {
      innerHtml: '',
    }
  },
  mounted() {
    this.getHeaderHtml()
  },
  methods: {
    async getHeaderHtml() {
      const res = await getHeaderHtml()
      if (res) {
        this.innerHtml = res
        // this.innerHtml = res.replace(
        //   /<link[^>]*rel=["']stylesheet["'][^>]*>/gi,
        //   ''
        // )
        this.addEvents()
      }
    },
    addEvents() {
      $(function () {
        $('.top-app').show()
        // $('.submenu-app').css('display', 'flex')
        // 头部隐藏
        let lastScrollTop = 0
        let top = $('.top-app')

        window.addEventListener('scroll', () => {
          const currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop

          // 当页面滚动超过400px时
          if (currentScrollTop > 400) {
            if (currentScrollTop > lastScrollTop) {
              // 向下滚动，隐藏头部
              top.addClass('top-hidden')
            } else {
              // 向上滚动，显示头部
              top.removeClass('top-hidden')
            }
          } else {
            // 如果滚动位置少于100px，显示头部
            top.removeClass('top-hidden')
          }

          lastScrollTop = currentScrollTop
        })
        // 导航栏
        function expandBtnEvent(dom) {
          $(dom).click(function () {
            $('.submenu-app').toggleClass('submenu-show')
            if ($('.index').css('overflow') === 'hidden') {
              $('.index').css('overflow', 'visible')
            } else {
              $('.index').css('overflow', 'hidden')
            }
            if (dom.indexOf('close') !== -1) {
              back()
            }
          })
        }
        expandBtnEvent('.menu-expand')
        expandBtnEvent('.submenu-head .close')
        function back() {
          $('.submenu-head .submenu-title').text('')
          $('.main_m').addClass('main_m_show')
          $('.menu-detail-panel').removeClass('menu-detail-panel-show')
          $('.submenu-head .back').removeClass('back-show')
        }
        $('.submenu-head .back').click(function () {
          back()
        })
        $('.main_m .expand').click(function () {
          let index = $('.main_m .expand').index(this)
          let title = $(this).find('div').text()
          $('.submenu-head .submenu-title').text(title)
          $('.menu-detail-panel')
            .eq(index)
            .addClass('menu-detail-panel-show')
            .siblings()
            .removeClass('menu-detail-panel-show')
          $('.submenu-head .back').toggleClass('back-show')
          $('.main_m').toggleClass('main_m_show')
        })
        // 左侧菜单点击
        $('.menu-detail-panel').each(function () {
          var panel = $(this) // 当前的 menu-detail-panel
          // 为左侧菜单的每个 li 添加点击事件
          panel.find('.left-menu-ul li').click(function () {
            // 获取当前点击的 li 的索引
            var index = $(this).index()
            // 移除所有右侧面板的显示类，仅限当前的 menu-detail-panel 范围内
            panel
              .find('.right-active-panel')
              .removeClass('right-active-panel-show')
            // 根据索引为相应的右侧面板添加显示类
            panel
              .find('.right-active-panel')
              .eq(index)
              .addClass('right-active-panel-show')
            // 移除所有左侧菜单项的选中状态，仅限当前的 menu-detail-panel 范围内
            panel.find('.left-menu-ul li').removeClass('left-active')
            // 为当前点击的菜单项添加选中状态
            $(this).addClass('left-active')
          })
        })
        // 右侧展开
        // $('.right-active-ul .expand').click(function () {
        //   $(this).find('img').addClass('arrowDown')
        //   $(this).siblings().slideDown()
        // })
        $('.right-active-ul .expand').click(function () {
          // 当前点击的元素
          var $currentExpand = $(this)

          // 找到所有同级的元素并收起
          $currentExpand
            .parent()
            .siblings()
            .find('.children-1, .children-2')
            .slideUp()

          // 当前点击的元素展开
          $currentExpand.siblings().slideDown()

          // 移除其他同级元素的箭头向下状态
          $currentExpand
            .parent()
            .siblings()
            .find('img')
            .removeClass('arrowDown')

          // 当前箭头添加向下状态
          $currentExpand.find('img').addClass('arrowDown')
        })

        $('.submenu-app a').click(()=>{
          $('.submenu-app').toggleClass('submenu-show')
            if ($('.index').css('overflow') === 'hidden') {
              $('.index').css('overflow', 'visible')
            } else {
              $('.index').css('overflow', 'hidden')
            }
          back()
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('@/assets/style/common/common.css');
@import url('@/assets/style/common/global.css');
</style>
